import { useMutation } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import { AxiosError } from "axios";
import toastMessages from "../../helpers/toastMessage";

interface AddDocumentWithPathsPayload {
  orderId: string;
  transitDocuments: string[]; // Array of file paths
}

function useAddDocumentWithPaths() {
  const { authState } = useOktaAuth();

  return useMutation({
    mutationKey: ["addDocumentWithPaths"],
    mutationFn: (payload: AddDocumentWithPathsPayload) => {
      return axiosInstance.post(
        "/v1/orders/new-flow/add-document",
        payload,
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );
    },
    onSuccess: () => {
      toastMessages.success("Upload documents successful");
    },
    onError: (error: AxiosError<any, any>) => {
      const errorMessage =
        error?.response?.data?.message ?? "Upload documents failed";
      toastMessages.error(errorMessage);
    },
  });
}

export default useAddDocumentWithPaths;
